import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Button } from "../components/ui/button"
import { Menu, X, ChevronDown } from "lucide-react"

export function HeaderNav() {
  const [isOpen, setIsOpen] = useState(false)
  const [activeSubmenu, setActiveSubmenu] = useState(null)
  const [activeNestedSubmenu, setActiveNestedSubmenu] = useState(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target
      if (isOpen && !target.closest('[data-menu="true"]')) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isOpen])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsOpen(false)
      }
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const toggleSubmenu = (menu) => {
    setActiveSubmenu(activeSubmenu === menu ? null : menu)
  }

  const toggleNestedSubmenu = (menu) => {
    setActiveNestedSubmenu(activeNestedSubmenu === menu ? null : menu)
  }

  const menuItems = [
    { name: "Home", href: "/" },
    {
      name: "About",
      href: "/about",
      submenu: [
        { name: "About Us", href: "/about" },
        { name: "History", href: "./about/history" },
        { name: "Awards and Achievements ", href: "./about/awards" },
        { name: "Facilities", href: "./about/facilities" },
        { name: "Infrastructure", href: "./about/infrastructure" },
        { name: "Pranaam at Glance", href: "./about/pranaamGlance" },
        { name: "In The News", href: "./about/inthenews" },
        { name: "Contact", href: "/contact" },
      ],
    },
    { name: "Maternity Matters", href: "/maternity-matters" },
    {
      name: "Locations",
      href: "/locations",
      submenu: [
        { name: "Madinaguda", href: "/locations/madinaguda" },
        { name: "Nallagandla", href: "/locations/nallagandla" },
        { name: "Isnapur", href: "/locations/isnapur" },
        { name: "Zaheerabad", href: "/locations/zaheerabad" },
      ],
    },
    {
      name: "Services",
      href: "/services",
      submenu: [
        { name: "Cardiology", href: "/services/cardiology" },
        { name: "Neurology", href: "/services/neurology" },
        { name: "Orthopedics", href: "/services/orthopedics" },
        { name: "Paediatric", href: "/services/paediatric" },
        { name: "Paediatric Surgery", href: "/services/paediatric-surgery" },
        { name: "Gynaecology", href: "/services/gynaecology" },
        { name: "Dentistry", href: "/services/dentistry" },
        { name: "Gastroenterology", href: "/services/gastroenterology" },
        { name: "General Surgery", href: "/services/general-surgery" },
        { name: "General Medicine", href: "/services/general-medicine" },
        { name: "Neonatology", href: "/services/neonatology" },
        { name: "Prenatal Yoga", href: "/services/prenatal-Yoga" }, 
        { name: "Critical Care", href: "/services/critical-care" },
        { name: "Pathology", href: "/services/pathology" },
        { name: "Neurosurgery", href: "/services/neuro-surgery" },
        { name: "Oncology", href: "/services/oncology" },
        { name: "Urology & Nephrology", href: "/services/urology-nephrology" },
        { name: "Laparoscopic Surgery", href: "/services/laparoscopic-surgery" },
        { name: "Physiotherapy", href: "/services/physiotherapy" },
        { name: "Dietetics", href: "/services/dietetics" },
        { name: "Dermatology", href: "/services/dermatology" },
        { name: "ENT", href: "/services/ent" },
        { name: "Endocrinology", href: "/services/endocrinology" },
        { name: "Pulmonology", href: "/services/pulmonology" },
        { name: "Plastic & CosmeticSurgery", href: "/services/Plastic-Cosmetic-Surgery" },
        { name: "Psychology", href: "/services/psychology" },
        { name: "Radiology", href: "/services/Radiology" },
      ],
     
    },
    { name: "Diagnostics", href: "/diagnostics" },

    {
      name: "Media",
      href: "/media",
      submenu: [
        { name: "Videos", href: "/videos" },
        { name: "Blogs", href: "/blogs" },
       
      ],
    },
    { name: "Doctors", href: "/doctors" },
  ]

  return (
    <>
      <nav className="hidden md:flex items-center space-x-6" data-menu="true">
        {menuItems.map((item) => (
          <div key={item.name} className="relative group">
            {item.submenu ? (
              <>
                <button
                  className="flex items-center text-sm font-medium hover:text-primary"
                  onClick={() => toggleSubmenu(item.name)}
                >
                  {item.name}
                  <ChevronDown className="w-4 h-4 ml-1" />
                </button>
                {/* <div className="absolute left-0 z-10 w-[45rem] mt-2 origin-top-left bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 whitespace-nowrap"> */}
                <div
                  className={`absolute left-0 z-10 mt-2 origin-top-left bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 whitespace-nowrap ${
                    item.name === "Services"
                      ? "w-[45rem]"
                      : "w-[15rem]"
                  }`}
                >
                  <div className="py-1">
                    <div
                      className={`p-2 gap-y-4 w-full max-w-5xl ${
                        item.name === "Services"
                          ? "grid grid-cols-3 gap-x-[6rem]"
                          : "grid grid-cols-1"
                      }`}
                    >
                    {item.submenu.map((subitem) => (
                      <div key={subitem.name} className="relative group/nested">
                        {subitem.submenu ? (
                          <>
                            <div className="flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-primary">
                              <span>{subitem.name}</span>
                              <ChevronDown className="w-3 h-3 ml-1" />
                            </div>
                            <div className="absolute left-full top-0 z-20 w-48 origin-top-left bg-white rounded-md shadow-lg opacity-0 invisible group-hover/nested:opacity-100 group-hover/nested:visible transition-all duration-300">
                              <div className="py-1">
                                {subitem.submenu.map((nestedItem) => (
                                  <Link
                                    key={nestedItem.name}
                                    to={nestedItem.href}
                                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-primary"
                                  >
                                    {nestedItem.name}
                                  </Link>
                                ))}
                              </div>
                            </div>
                          </>
                        ) : (
                          <Link
                            to={subitem.href}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-primary"
                          >
                            {subitem.name}
                          </Link>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                </div>
              </>
            ) : (
              <Link to={item.href} className="text-sm font-medium hover:text-primary">
                {item.name}
              </Link>
            )}
          </div>
        ))}
      </nav>

      <Button
        variant="ghost"
        size="icon"
        className="md:hidden relative z-999"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-label="Toggle menu"
        data-menu="true"
        style={{ zIndex: 999 }}
      >
        <span className="sr-only">Toggle menu</span>
        {isOpen ? <X className="w-5 h-5 z-999" /> : <Menu className="w-5 h-5" />}
      </Button>

      {isOpen && (
        <div
          className="fixed inset-0 z-999 bg-black/20 backdrop-blur-sm md:hidden"
          aria-hidden="true"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="absolute top-16 right-0 w-full max-w-sm h-[calc(100vh-4rem)] bg-white shadow-xl p-6 overflow-y-auto z-999"
            onClick={(e) => e.stopPropagation()}
            data-menu="true"
          >
            <nav className="flex flex-col space-y-4">
              {menuItems.map((item) => (
                <div key={item.name} className="border-b border-gray-100 pb-2">
                  {item.submenu ? (
                    <div>
                      <button
                        className="flex items-center justify-between w-full text-left text-sm font-medium py-2"
                        onClick={() => toggleSubmenu(item.name)}
                      >
                        {item.name}
                        <ChevronDown
                          className={`w-4 h-4 transition-transform ${activeSubmenu === item.name ? "rotate-180" : ""}`}
                        />
                      </button>
                      {activeSubmenu === item.name && (
                        <div className="ml-4 mt-2 space-y-2">
                          {item.submenu.map((subitem) => (
                            <div key={subitem.name}>
                              {subitem.submenu ? (
                                <>
                                  <button
                                    className="flex items-center justify-between w-full text-left text-sm py-2 text-muted-foreground hover:text-primary"
                                    onClick={() => toggleNestedSubmenu(subitem.name)}
                                  >
                                    {subitem.name}
                                    <ChevronDown
                                      className={`w-3 h-3 transition-transform ${activeNestedSubmenu === subitem.name ? "rotate-180" : ""}`}
                                    />
                                  </button>
                                  {activeNestedSubmenu === subitem.name && (
                                    <div className="ml-4 mt-1 space-y-2">
                                      {subitem.submenu.map((nestedItem) => (
                                        <Link
                                          key={nestedItem.name}
                                          to={nestedItem.href}
                                          className="block py-2 text-sm text-muted-foreground hover:text-primary"
                                          onClick={() => setIsOpen(false)}
                                        >
                                          {nestedItem.name}
                                        </Link>
                                      ))}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <Link
                                  to={subitem.href}
                                  className="block py-2 text-sm text-muted-foreground hover:text-primary"
                                  onClick={() => setIsOpen(false)}
                                >
                                  {subitem.name}
                                </Link>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <Link
                      to={item.href}
                      className="block py-2 text-sm font-medium hover:text-primary"
                      onClick={() => setIsOpen(false)}
                    >
                      {item.name}
                    </Link>
                  )}
                </div>
              ))}
            </nav>
          </div>
        </div>
      )}
    </>
  )
}